<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <g clip-path="url(#clip0_2557_710)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.833374 10C0.833374 15.0542 4.94587 19.1667 10 19.1667C15.0542 19.1667 19.1667 15.0542 19.1667 10C19.1667 4.94584 15.0542 0.833344 10 0.833344C4.94587 0.833344 0.833374 4.94584 0.833374 10ZM2.50004 10C2.50004 5.86418 5.86504 2.50001 10 2.50001C11.768 2.50001 13.3952 3.115 14.6788 4.14235L4.14237 14.6788C3.11507 13.3953 2.50004 11.7682 2.50004 10ZM5.32084 15.8573C6.60452 16.8849 8.23188 17.5 10 17.5C14.135 17.5 17.5 14.1358 17.5 10C17.5 8.23165 16.8849 6.60437 15.8574 5.3208L5.32084 15.8573Z"
                fill="#F18169"
            />
        </g>
        <defs>
            <clipPath id="clip0_2557_710">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
